import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=ea0bb544"
import script from "./purchased.vue?vue&type=script&lang=js"
export * from "./purchased.vue?vue&type=script&lang=js"
import style0 from "./purchased.vue?vue&type=style&index=0&id=ea0bb544&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports